import { forwardRef } from "react";
import { Link as RouterLink, NavLink as RouterNavLink, Navigate as RouterNavigate } from "react-router-dom";
import { useLanguage } from "../i18n/LanguageContext";
import { localizePath } from "../i18n/localePath";
import { useVersion } from "../version/VersionContext";
import { versionPath } from "../version/routes";

export const Link = forwardRef(({ to, ...props }, ref) => {
    const { lang: contentLang, uiLang } = useLanguage();
    const lang = uiLang || contentLang;
    const { version } = useVersion();
    return <RouterLink ref={ref} to={localizePath(versionPath(to, version), lang)} {...props} />;
});

Link.displayName = "LocalizedLink";

export const NavLink = forwardRef(({ to, ...props }, ref) => {
    const { lang: contentLang, uiLang } = useLanguage();
    const lang = uiLang || contentLang;
    const { version } = useVersion();
    return <RouterNavLink ref={ref} to={localizePath(versionPath(to, version), lang)} {...props} />;
});

NavLink.displayName = "LocalizedNavLink";

export const Navigate = ({ to, ...props }) => {
    const { lang: contentLang, uiLang } = useLanguage();
    const lang = uiLang || contentLang;
    const { version } = useVersion();
    return <RouterNavigate to={localizePath(versionPath(to, version), lang)} {...props} />;
};
